import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { CustomTable } from "elements/DEPRECATED_elements";
import { CustomHeaderCell } from "elements/DEPRECATED_elements";
import { Typography, Box, Avatar, Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import DaysAvailability from "./DaysAvailability";
import { ANNoResultsOverlay, ANTooltip } from "@answersnow/pkg-theme";
import { formatNextAppointment, getStatusColor } from "./utils";

const ClientTable = ({
  clients,
  handleDetailsClick,
  page,
  rowsPerPage,
  count,
  handleChangePage,
  handleChangeRowsPerPage,
  handleClearFilters,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        margin: "0 -24px -24px -24px",
        padding: "0px",
        [theme.breakpoints.down("xl")]: {
          margin: "0 -10px -10px -10px",
          padding: "0px",
        },
      }}
    >
      <CustomTable
        noResultsMessage=""
        count={clients.length > 0 ? count : 1}
        rowsPerPage={rowsPerPage}
        page={page}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        headerCells={[
          <CustomHeaderCell
            key="client"
            label="Client"
            style={{ maxWidth: "160px", padding: "16px" }}
          />,
          <CustomHeaderCell key="availability" label="Availability" />,
          <CustomHeaderCell key="insurance" label="Insurance" style={{ maxWidth: "160px" }} />,
          <CustomHeaderCell
            key="clinician"
            label="Clinician"
            style={{ maxWidth: "160px", padding: "16px" }}
          />,
          <CustomHeaderCell
            key="supervisor"
            label="Supervisor"
            style={{ maxWidth: "160px", padding: "16px" }}
          />,
          <CustomHeaderCell key="status" label="Status" />,
          <CustomHeaderCell
            key="next-appointment"
            label="Next appointment"
            style={{ whiteSpace: "nowrap" }}
          />,
        ]}
      >
        {clients.length === 0 ? (
          <TableRow>
            <TableCell colSpan={7} align="center" style={{ padding: 0, border: "none" }}>
              <Box height="236px" display="flex" alignItems="center" justifyContent="center">
                <ANNoResultsOverlay handleClearFilters={handleClearFilters} />
              </Box>
            </TableCell>
          </TableRow>
        ) : (
          clients.map((row, index) => {
            const { time, fullDate } = formatNextAppointment(row.next_appointment_date);

            return (
              <TableRow key={index}>
                <TableCell
                  align="left"
                  style={{
                    maxWidth: "160px",
                    padding: "16px",
                  }}
                >
                  <ANTooltip
                    component={Typography}
                    onClick={handleDetailsClick(row.client_id)}
                    sx={{
                      color: "#8E42CA",
                      cursor: "pointer",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 400,
                    }}
                  >
                    {`${row.client_first_name} ${row.client_last_name}`}
                  </ANTooltip>
                </TableCell>
                <TableCell align="left" style={{ fontWeight: "500", color: "#4e4e4e" }}>
                  <DaysAvailability availability={row.week_availability} />
                </TableCell>
                <TableCell
                  align="left"
                  style={{
                    maxWidth: "160px",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  <Typography
                    variant="body2"
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {row.insurance || "N/A"}
                  </Typography>

                  {row.insurance && row.insurance_plan_name && (
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {row.insurance_plan_name}
                    </Typography>
                  )}
                </TableCell>
                <TableCell
                  align="left"
                  style={{
                    maxWidth: "160px",
                    padding: "16px",
                  }}
                >
                  {row.primary_clinician_user_id ? (
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={1}
                      style={{
                        minWidth: 0,
                        overflow: "hidden",
                      }}
                    >
                      <Avatar
                        size="24px"
                        variant="circular"
                        src={row.primary_clinician_image}
                        style={{ flexShrink: 0 }}
                      ></Avatar>
                      <ANTooltip
                        component={Typography}
                        variant="body2"
                        color="textSecondary"
                        style={{ minWidth: 0 }}
                      >
                        {`${row.primary_clinician_first_name} ${row.primary_clinician_last_name}`}
                      </ANTooltip>
                    </Box>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      N/A
                    </Typography>
                  )}
                </TableCell>
                <TableCell
                  align="left"
                  style={{
                    maxWidth: "160px",
                    padding: "16px",
                  }}
                >
                  {row.supervisor_user_id ? (
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={1}
                      style={{
                        minWidth: 0,
                        overflow: "hidden",
                      }}
                    >
                      <Avatar
                        size="24px"
                        variant="circular"
                        src={row.supervisor_image}
                        style={{ flexShrink: 0 }}
                      ></Avatar>
                      <ANTooltip
                        component={Typography}
                        variant="body2"
                        color="textSecondary"
                        style={{ minWidth: 0 }}
                      >
                        {`${row.supervisor_first_name} ${row.supervisor_last_name}`}
                      </ANTooltip>
                    </Box>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      N/A
                    </Typography>
                  )}
                </TableCell>
                <TableCell align="left">
                  <Chip
                    label={row.client_status || "Unknown"}
                    size="small"
                    variant="outlined"
                    color={getStatusColor(row.client_status) || "Unknown"}
                  ></Chip>
                </TableCell>
                <TableCell align="left">
                  <Typography variant="body2" style={{ textWrap: "nowrap" }}>
                    {time}
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    {fullDate}
                  </Typography>
                </TableCell>
              </TableRow>
            );
          })
        )}
      </CustomTable>
    </Box>
  );
};

export default ClientTable;
